import React from 'react';
import styles from './NeedInfoSkeleton.module.scss';
import tableStyles from '../../NeedInfoV2.module.scss';
import { useSearchParams } from 'react-router-dom';
import { SOURCE } from '../../NeedInfoV2Constants';
import { useAppSelector } from '../../../../app/hooks';
import { USER_TYPE } from '../../../../utils/constants/user';

const NeedInfoSkeleton = ({ count = 5 }: { count?: number }) => {
    const [searchParams] = useSearchParams();
    const accountType = useAppSelector((state) => state.user.userData.accountType);
    const isCompanySide =
        (location.pathname.includes('company') && !location.pathname.includes('company-deals')) || accountType === USER_TYPE.COMPANY;

    const SkeletonRow = () => (
        <tr className={tableStyles.TableRow}>
            {!isCompanySide && (
                <td style={{ width: '3%' }} className={tableStyles.TableCell}>
                    <div className={`${styles.SkeletonBase} ${styles.CheckboxSkeleton}`} />
                </td>
            )}
            <td
                style={isCompanySide ? { width: '40%', padding: '0 1rem' } : { width: '40%', paddingRight: '0.5rem' }}
                className={tableStyles.TableCell}
            >
                <div className={`${styles.SkeletonBase} ${styles.TextSkeleton}`} style={{ width: '80%', height: '16px' }} />
                <div
                    className={`${styles.SkeletonBase} ${styles.TextSkeleton}`}
                    style={{ width: '60%', height: '16px', marginTop: '8px' }}
                />
            </td>
            <td style={{ width: '15%', paddingRight: '0.5rem' }} className={tableStyles.TableCell}>
                <div className={`${styles.SkeletonBase} ${styles.TextSkeleton}`} style={{ width: '90%', height: '20px' }} />
            </td>
            <td style={{ width: '15%', paddingRight: '0.5rem' }} className={tableStyles.TableCell}>
                <div className={`${styles.SkeletonBase} ${styles.DataTypeSkeleton}`} />
            </td>
            {searchParams.get(SOURCE.BORROWER_REQ) === 'true' && (
                <td style={{ width: '10%', padding: '0.5rem' }} className={tableStyles.TableCell}>
                    <div className={`${styles.SkeletonBase} ${styles.TextSkeleton}`} style={{ width: '90%', height: '20px' }} />
                </td>
            )}
            <td style={{ width: '10%' }} className={tableStyles.TableCell}>
                <div className={`${styles.SkeletonBase} ${styles.TextSkeleton}`} style={{ width: '80%', height: '16px' }} />
                <div
                    className={`${styles.SkeletonBase} ${styles.TextSkeleton}`}
                    style={{ width: '50%', height: '12px', marginTop: '8px' }}
                />
            </td>
            {searchParams.get(SOURCE.BORROWER_REQ) === 'true' && (
                <td style={{ width: '5%' }} className={tableStyles.TableCell}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className={`${styles.SkeletonBase} ${styles.DotsSkeleton}`} />
                    </div>
                </td>
            )}
        </tr>
    );

    return (
        <tbody>
            {Array.from({ length: count }).map((_, index) => (
                <SkeletonRow key={index} />
            ))}
        </tbody>
    );
};

export default NeedInfoSkeleton;
